import React, { useContext } from 'react';
import Context from '../Context';
import cx from 'classnames';

export const TASK_LIST_HEADER_HEIGHT = 130;
export const TASK_LIST_BULK_SELECT_HEIGHT = 60;

export interface HeaderContainerProps {
  children: React.ReactNode;
}

export function HeaderContainer({
  children
}: HeaderContainerProps){
  const { bulkSelect } = useContext(Context);
  return (
    <div className={cx([
      'flex items-center justify-between border border-solid border-neutral-100',
      'transition-all duration-400',
    ], {
      'min-h-[130px] h-[130px]': !bulkSelect.data.any,
      'min-h-[60px] h-[60px]' : bulkSelect.data.any,
    })}>
      {children}
    </div>
  );
}
export default HeaderContainer;
